var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22.000000pt",
    height: "22.000000pt",
    viewBox: "0 0 22.000000 22.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,22.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 212 c-9 -6 -12 -26 -10 -58 l3 -49 48 -3 48 -3 -3 58 -3 58 -35 3 c-19 1 -41 -2 -48 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 206 c-11 -30 1 -61 25 -64 58 -9 83 15 65 62 -8 21 -82 22 -90 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 63 c3 -52 5 -58 27 -61 12 -2 34 -1 48 2 22 6 24 11 21 59 l-3 52 -48 3 -48 3 3 -58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 74 c-15 -6 -17 -42 -4 -62 5 -8 23 -12 47 -10 37 3 39 5 39 38 0 33 -2 35 -35 37 -19 1 -41 0 -47 -3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f2277fa3023f761df9fd60a9882f4bf1.svg";
export { ForwardRef as ReactComponent };